// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".STf\\+-{position:relative;min-height:300px;background-color:#fff;box-shadow:0 0 40px rgba(0,0,0,.05)}@media screen and (min-width:768px){.STf\\+-{box-shadow:none}}.m1wKC{padding:0 16px}@media screen and (min-width:768px){.m1wKC{padding:0 32px 16px;border:1px solid #e2e2e2;margin-top:16px;border-radius:8px}}.SRY9a{margin-bottom:24px}.SRY9a>span{color:#f02d37}.HHBod{display:flex;align-items:center;justify-content:space-between;padding:32px 0 24px;margin-right:-8px}@media screen and (min-width:768px){.HHBod{border:0}}.EbiW-{font-family:\"Merriweather\",serif;font-size:22px;font-weight:700;line-height:28px}.EbiW->span{color:#c3c3c3}.HRW5A{width:32px;height:28px;cursor:pointer}.STf\\+- ._3NkjM{border-top:1px solid #e2e2e2}@media screen and (min-width:768px){.STf\\+- ._3NkjM{border:0}}@media screen and (min-width:768px){.STf\\+- ._3NkjM+._3NkjM{border-top:1px solid #e2e2e2}}.q17Bs{text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "STf+-",
	"results": "m1wKC",
	"notFound": "SRY9a",
	"header": "HHBod",
	"total": "EbiW-",
	"sortArrows": "HRW5A",
	"article": "_3NkjM",
	"paginationWrapper": "q17Bs"
};
module.exports = ___CSS_LOADER_EXPORT___;
